import { TProductRefId } from "@/types/plan";
import { TPlan } from "../types.checkout";

export const getPlanByProdRefId = (
  planCards: TPlan[],
  productRefId: TProductRefId | string,
) => {
  return planCards.find((plan) => plan.productRefId === productRefId);
};
